document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.dropdown');
  if (!dropdowns.length) return;

  const updateMultiSelect = (dropdown) => {
    countSelected(dropdown);
  };

  const initDropdown = (dropdown) => {
    const filterEle = dropdown.closest('.product-filter');
    const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
    const defaultPlaceholder = placeholderText.dataset.placeholder;
    const { originalPlaceholder } = placeholderText.dataset;

    if (dropdown.classList.contains('dropdown--multiselect')) {
      updateMultiSelect(dropdown);
      return;
    }

    updateSingleSelect(dropdown, placeholderText);

    const checkedInput = dropdown.querySelector('.dropdown__list-inner input:checked');
    if (checkedInput && !filterEle) {
      const optionLabel = checkedInput.nextElementSibling;
      placeholderText.textContent = optionLabel?.textContent.trim();
      dropdown.classList.add('is-selected');
      return;
    }

    placeholderText.textContent = originalPlaceholder || defaultPlaceholder;
  };

  // --- Initialize all dropdowns ---
  dropdowns.forEach(initDropdown);

  // --- Global click handler (event delegation) ---
  dropdownGlobalHandler();

  // --- Multi-select: listen to checkbox changes ---
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.dropdown--multiselect .dropdown__list-inner input');
    if (!input) return;
    const dropdown = input.closest('.dropdown');
    updateMultiSelect(dropdown);
  });

  // --- Search filter ---
  document.querySelectorAll('.dropdown__search-input').forEach((input) => {
    input.addEventListener('input', () => {
      const searchValue = input.value.toLowerCase();
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-option')
        .forEach((option) => {
          option.closest('.dropdown__list-item').style.display = option.textContent.toLowerCase().includes(searchValue)
            ? 'block'
            : 'none';
        });
    });
  });

  // --- Reset search inputs on outside click ---
  document.addEventListener('click', (event) => {
    if (event.target.closest('.dropdown')) return;

    document.querySelectorAll('.dropdown__search-input').forEach((input) => {
      input.value = '';
      input
        .closest('.dropdown')
        .querySelectorAll('.dropdown__list-item')
        .forEach((item) => (item.style.display = 'block'));
    });
  });
});
